import React from "react";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { CommissionCharge as CommissionChargeModel } from "../../../../../../../Wrap/Models/Models/Charges/CommissionCharge";
import { ContributionAndWithdrawalBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/ContributionAndWithdrawalBase";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Table } from "../../../../../../Shared/Table/Table";
import { SPTAction } from "../../../SinglePaymentTransferWizard/Actions/SPTActions";
import { SectionHeader } from "../../SharedComponents";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { CommissionChargeMessage } from "./CommissionChargeMessage";

interface ICommissionChargeProps extends IProcessComponentProps {
    headAccountHierarchyId: string;
    data: ContributionAndWithdrawalBase;
    processType: ProcessType;
}

interface ICommissionChargeState {
    charges: CommissionChargeModel[];
}

export class CommissionCharge extends ProcessComponent<ICommissionChargeProps, ICommissionChargeState> {
    constructor(props: any) {
        super(props);
        this.state = {
            charges: [],
        };
    }

    componentDidMount() {
        super.componentDidMount();
        SPTAction.getCommissionCharges(this.props.headAccountHierarchyId, (d) => {
            this.setState({ charges: d });
        });
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const { charges } = this.state;
        if (!charges || charges.length == 0) {return null;}
        return (
            <>
                <hr />

                <CommissionChargeMessage
                    processType={this.props.processType}
                    cancelAll={true}
                    message={`Selecting "Cancel All Trail Commission/Wrap fees" will stop existing commission arrangements on all sub-accounts, under this account.`}
                />

                {SectionHeader("FBRC")}
                <Table
                    data={charges}
                    col={[
                        { title: "Product name", key: "ProductName" },
                        {
                            title: "Rate",
                            key: "Rate",
                            render: (data: number) => {
                                return data.toFixed(2) + "%";
                            },
                        },
                        {
                            title: "Frequency",
                            key: "Frequency",
                            render: (data: string) => {
                                switch (data.toLowerCase()) {
                                    case "m":
                                        return "Monthly";
                                    case "q":
                                        return "Quarterly";
                                    case "s":
                                        return "Half Yearly";
                                    case "a":
                                        return "Annually";
                                    default:
                                        return "";
                                }
                            },
                        },
                    ]}
                />
                <CheckboxEditor
                    label={"Cancel All Trail Commission/Wrap fees"}
                    cssWrapper="square-checkbox "
                    value={data.CancelAllCommissionCharges}
                    onChange={(v) => onChange({ CancelAllCommissionCharges: v })}
                />
            </>
        );
    }
}
